import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isFlowEngineEnabledForProcess, resolveFlowRoleContext } from '../../../app/helpers/flowEngineConfigHelper';
import { getCollapsedSectionHeaderKey, shouldCollapseDriSections } from '../../../app/helpers/flowFichaSectionHelper';
import { resolveNewEditVisibilityFlag } from '../../../app/helpers/moduleConfigPreNewEditHelper';
import { getSectionHeader, isSectionNewEditVisible } from '../../../app/helpers/helperValidationViewPreview';
import DynamicFormEngine from '../../dynamic-form/DynamicFormEngine';
import ViewSectionAccordeon from '../../generic-component/ViewSectionAccordion';

const FlowFichaSections = ({
  record,
  process,
  arrayListPrincipal,
  arrayListSecondary,
  sharedFormProps,
  visibilityFlag
}) => {
  const { t } = useTranslation();
  const userRole = useSelector((state) => state.userRole);
  const auth = useSelector((state) => state.auth);
  const configuration = useSelector((state) => state.configuration);
  const resolvedVisibilityFlag = visibilityFlag
    || resolveNewEditVisibilityFlag({ userRole, record, process });

  const roleContext = useMemo(
    () => resolveFlowRoleContext({ userRole, authUser: auth?.user }),
    [userRole, auth]
  );

  const collapse = shouldCollapseDriSections({
    record,
    process,
    roleKey: roleContext.roleCode,
    flowEnabled: isFlowEngineEnabledForProcess(configuration, process)
  });

  const principalHeader = collapse
    ? t(getCollapsedSectionHeaderKey(roleContext.roleCode))
    : getSectionHeader(arrayListPrincipal);
  const secondaryHeader = getSectionHeader(arrayListSecondary);

  return (
    <Accordion defaultActiveKey="0" flush alwaysOpen>
      {collapse ? (
        (isSectionNewEditVisible(arrayListPrincipal) || isSectionNewEditVisible(arrayListSecondary)) && (
          <Accordion.Item eventKey="0" key="dri-collapsed" className="accordionSeccion">
            <Accordion.Header>
              <ViewSectionAccordeon header={principalHeader} />
            </Accordion.Header>
            <Accordion.Body>
              <div className="row">
                {isSectionNewEditVisible(arrayListPrincipal) && (
                  <DynamicFormEngine list={arrayListPrincipal} {...sharedFormProps} visibilityFlag={resolvedVisibilityFlag} />
                )}
                {isSectionNewEditVisible(arrayListSecondary) && (
                  <DynamicFormEngine list={arrayListSecondary} {...sharedFormProps} visibilityFlag={resolvedVisibilityFlag} />
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )
      ) : (
        <>
          {isSectionNewEditVisible(arrayListPrincipal) && (
            <Accordion.Item eventKey="0" key="1" className="accordionSeccion">
              <Accordion.Header>
                <ViewSectionAccordeon header={principalHeader} />
              </Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <DynamicFormEngine list={arrayListPrincipal} {...sharedFormProps} visibilityFlag={resolvedVisibilityFlag} />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}
          {isSectionNewEditVisible(arrayListSecondary) && (
            <Accordion.Item eventKey="1" key="2" className="accordionSeccion">
              <Accordion.Header>
                <ViewSectionAccordeon header={secondaryHeader} />
              </Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <DynamicFormEngine list={arrayListSecondary} {...sharedFormProps} visibilityFlag={resolvedVisibilityFlag} />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}
        </>
      )}
    </Accordion>
  );
};

FlowFichaSections.propTypes = {
  record: PropTypes.object,
  process: PropTypes.string.isRequired,
  arrayListPrincipal: PropTypes.array,
  arrayListSecondary: PropTypes.array,
  sharedFormProps: PropTypes.object.isRequired,
  visibilityFlag: PropTypes.string
};

export default FlowFichaSections;
